import { Injectable } from '@angular/core';
import { EligibilityCertificateUrlServices } from './eligibility-certificate-model';
import { HttpServiceService } from 'src/app/common-service/http-service.service';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';
import { ServerURLService } from 'src/app/common-service/serverURL.service';
import { encryptionService } from 'src/app/common-service/cedService';

@Injectable({
  providedIn: 'root'
})

export class  EligibilityCertificateService {

  constructor(public http: HttpServiceService,private url: EligibilityCertificateUrlServices,
    private spinner: NgxSpinnerService, private toastr: ToastrService,public serverURL: ServerURLService,public ced: encryptionService) { }
    public text: string = '';
    public yesnovalue: string = '';

  getApplicantEligibilityCertificate(eligibilityCertificateId){
    return this.http.get(this.url.applicantEligibilityCertificateUrl+eligibilityCertificateId);
  }

  getProfilePicUrl(fileName){
    const obj = {
      fileByteName : fileName,
    }
    return this.http.post(this.url.applicantProfileUrl,obj);
  }

  getProfilesignUrl(fileName){
    const obj = {
      fileByteName : fileName,
    }
    return this.http.post(this.url.applicantsignUrl,obj);
  }

  getAllCourses() {
    return this.http.get(this.url.ecCourseList);
  }


  getApplicantInfo(emailIdss){
    const obj = {
      emailId : emailIdss,
      roleName : this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString()  
    }
    return this.http.post(this.url.ecApplicantInfo,obj);
  }

  getApplicantEligibilityCertificateRegistrationDetails(eligibilityCertificateId){
    return this.http.get(this.url.ecApplicantRegistrationInfo+'?eligibilityCertificateId='+eligibilityCertificateId);
  }

  getEligibilityCertificateInfoForApproval(eligibilityCertificateId){
    const obj = {
      eligibilityCertificateId: this.ced.encryptAesToString(eligibilityCertificateId, this.serverURL.secretKey).toString(),
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.ecApprovalInfo, obj);
  }

  getEligibilityCertificateDetails(eligibilityCertificateId){
    return this.http.get(this.url.getEligibilityCertificateDetails+'?eligibilityCertificateId='+eligibilityCertificateId);
  }

  getApplicantDeficientComments(statusName,userId,eligibilityCertificateId){
    return this.http.get(this.url.getApplicantDeficientComments+'?statusName='+statusName + '&userId=' +  userId +   '&eligibilityCertificateId='+eligibilityCertificateId);
  }


  getECAssignedUserIdDetails(eligibilityCertificateId){
    return this.http.get(this.url.getECAssignedUserIdDetails+'?eligibilityCertificateId='+eligibilityCertificateId);
  }
  
  ecRegistration(data: any) {
    return this.http.post(this.url.ecRegistration, data);
  }

 ecStatuschange(data: any) {
    return this.http.post(this.url.ecStatuschange, data);
  }

  deficientStatusUpload(data: any) {
    return this.http.post(this.url.deficientStatusUpload, data);
  }

  retrieveEligibilityCertificatesForApproval(roleType: string){
    const obj = {
      roleName : this.ced.encryptAesToString(roleType, this.serverURL.secretKey).toString()  
    }
    return this.http.post(this.url.retrieveECForApproval,obj);
  }

  ecUpdateSecHeadStat(data: any) {
    return this.http.update(this.url.updateECApprovalStatus, data);
  }

  public loadEndate(date) {
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);
    return date.getFullYear()+'-'+month+'-'+day
  }

  public personalloadEndate(date) {
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);
    return date.getFullYear()-19+'-'+month+'-'+day
  }
  NewloadCompleteDetailInfo(){
    return [
      {'id':'1','text':'a) Name Of Course','type':'input', 'placeHolder':'course name','value':''},
      {'id':'2','text':'b) Date of Commencement','type':'date','value':''},
      {'id':'3','text':'c) Tentative Date of completion','type':'date','value':''},
      {'id':'4','text':'d) Course Duration','type':'input','value':''},
      {'id':'5','text':'e) Whether the course is recognized by their respective country/councils/governments for practice purpose ?','type':'radio','value':"YES"},
      {'id':'6','text':'f) Whether the course is recognized for PG teaching in respective university/institution ?','type':'radio','value':"YES"},
      {'id':'7','text':'g) Whether the course is a full time ?','type':'radio','value':"YES"},
      {'id':'8','text':'h) Whether the course content are similar to that of India ?','type':'radio','value':"YES"},
      {'id':'9','text':'i) Whether the subject wise teaching hours are similar to that of India ?','type':'radio','value':"YES"},
      {'id':'10','text':'j) Is there any Internship provision,','type':'radio','value':"YES"},
    ]
  }

  loadCompleteDetailInfo(){
    return [
      {'id':'1','text':'a) Name Of Course','type':'input', 'placeHolder':'course name','value':''},
      {'id':'2','text':'b) Date of Commencement','type':'date','value':''},
      {'id':'3','text':'c) Tentative Date of completion','type':'date','value':''},
      {'id':'4','text':'d) Course Duration','type':'input','value':''},
      {'id':'5','text':'e) Whether the course is recognized by their respective country/councils/governments for practice purpose ?','type':'radio','value':"YES"},
      {'id':'6','text':'f) Whether the course is recognized for PG teaching in respective university/institution ?','type':'radio','value':"YES"},
      {'id':'7','text':'g) Whether the course is a full time ?','type':'radio','value':"YES"},
      {'id':'8','text':'h) Whether the course content are similar to that of India ?','type':'radio','value':"YES"},
      {'id':'9','text':'i) Whether the subject wise teaching hours are similar to that of India ?','type':'radio','value':"YES"},
      {'id':'10','text':'j) Is there any Internship provision,','type':'radio','value':"YES"},
      {'id':'11','text':'1. Duration','type':'input','value':''},
      {'id':'12','text':'2. Roratory/Otherwise','type':'input','value':''},
    ]
  }

  uploadApplicantProfilePic(filearray: any, eligibilityCertificateId: string) {
    var files: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      files.append('files', filearray[i]);
    }
    return this.http.post(this.url.applicantProfileFileUpload+'?eligibilityCertificateId='+eligibilityCertificateId, files);
  }
  uploadApplicantsignPic(filearray: any, eligibilityCertificateId: string) {
    var files: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      files.append('files', filearray[i]);
    }
    return this.http.post(this.url.applicantsignFileUpload+'?eligibilityCertificateId='+eligibilityCertificateId, files);
  }
  uploadApplicantAdditionalDocuments(filearray: any, eligibilityCertificateId: string) {
    var files: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      files.append('files', filearray[i]);
    }
    return this.http.post(this.url.applicantDocumentsFileUpload+'?eligibilityCertificateId='+eligibilityCertificateId, files);
  }

  uploadApplicantReservedDocuments(filearray: any, eligibilityCertificateId: string) {
    var files: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      files.append('files', filearray[i]);
    }
    return this.http.post(this.url.applicantReservedFileUpload+'?eligibilityCertificateId='+eligibilityCertificateId, files);
  }
  uploadApplicantdegreeDocuments(filearray: any, eligibilityCertificateId: string) {
    var files: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      files.append('files', filearray[i]);
    }
    return this.http.post(this.url.applicantdegreeFileUpload+'?eligibilityCertificateId='+eligibilityCertificateId, files);
  }
  
  uploadApplicantEntranceDocuments(filearray: any, eligibilityCertificateId: string) {
    var files: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      files.append('files', filearray[i]);
    }
    return this.http.post(this.url.applicantEntranceFileUpload+'?eligibilityCertificateId='+eligibilityCertificateId, files);
  }
  uploadApplicantSchoolDocuments(filearray: any, eligibilityCertificateId: string) {
    var files: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      files.append('files', filearray[i]);
    }
    return this.http.post(this.url.applicantSchoolFileUpload+'?eligibilityCertificateId='+eligibilityCertificateId, files);
  }
  uploadApplicantpassportDocuments(filearray: any, eligibilityCertificateId: string) {
    var files: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      files.append('files', filearray[i]);
    }
    return this.http.post(this.url.applicantpassportFileUpload+'?eligibilityCertificateId='+eligibilityCertificateId, files);
  }
  uploadApplicantRelevantDocuments(filearray: any, eligibilityCertificateId: string) {
    var files: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      files.append('files', filearray[i]);
    }
    return this.http.post(this.url.applicantRelevantFileUpload+'?eligibilityCertificateId='+eligibilityCertificateId, files);
  }
  uploadApplicantadmissionDocuments(filearray: any, eligibilityCertificateId: string) {
    var files: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      files.append('files', filearray[i]);
    }
    return this.http.post(this.url.applicantadmissionFileUpload+'?eligibilityCertificateId='+eligibilityCertificateId, files);
  }

  uploadApplicantclearanceDocuments(filearray: any, eligibilityCertificateId: string) {
    var files: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      files.append('files', filearray[i]);
    }
    return this.http.post(this.url.applicantclearanceFileUpload+'?eligibilityCertificateId='+eligibilityCertificateId, files);
  }

  uploadApplicantbdsmarkDocuments(filearray: any, eligibilityCertificateId: string) {
    var files: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      files.append('files', filearray[i]);
    }
    return this.http.post(this.url.applicantbdsmarkFileUpload+'?eligibilityCertificateId='+eligibilityCertificateId, files);
  }

  uploadApplicantInstitutionDocuments(filearray: any, eligibilityCertificateId: string) {
    var files: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      files.append('files', filearray[i]);
    }
    return this.http.post(this.url.applicantInstitutionFileUpload+'?eligibilityCertificateId='+eligibilityCertificateId, files);
  }
  uploadApplicantAuthorityDocuments(filearray: any, eligibilityCertificateId: string) {
    var files: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      files.append('files', filearray[i]);
    }
    return this.http.post(this.url.applicantAuthorityFileUpload+'?eligibilityCertificateId='+eligibilityCertificateId, files);
  }

  uploadApplicantprospectusDocuments(filearray: any, eligibilityCertificateId: string) {
    var files: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      files.append('files', filearray[i]);
    }
    return this.http.post(this.url.applicantprospectusFileUpload+'?eligibilityCertificateId='+eligibilityCertificateId, files);
  }
  uploadApplicantcertificateSchool(filearray: any, eligibilityCertificateId: string) {
    var files: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      files.append('files', filearray[i]);
    }
    return this.http.post(this.url.applicantcertificateSchoolUpload+'?eligibilityCertificateId='+eligibilityCertificateId, files);
  }

  uploadApplicantMarksheetDocuments(filearray: any, eligibilityCertificateId: string) {
    var files: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      files.append('files', filearray[i]);
    }
    return this.http.post(this.url.applicantTwelvethFileUpload+'?eligibilityCertificateId='+eligibilityCertificateId, files);
  }

  deleteApplicantAdditionalDocument(additionalDocumentObj: any){
    return this.http.update(this.url.deleteApplicantUploadedDocument,additionalDocumentObj);
  }
  ecDocumentDelete(documentObj: any){
    return this.http.update(this.url.ecDocumentDelete,documentObj);
  }
  getApplicantDocument(fileName){
    const obj = {
      fileByteName : fileName,
    }
    return this.http.post(this.url.applicantDocumentUrl,obj);
  }


  openLoader(){
    this.spinner.show()
  }

  hideLoader(){
    this.spinner.hide()
  }

  displayMessage(type, msg){
    if(type === 'Error'){
      this.toastr.error(msg, 'Error', { timeOut: 3000});
    }
  }

  findEligibilityDashboardList(eligibilityDashboardSearchCriteria: any){
    return this.http.post(this.url.getEligibilityDashboardList, eligibilityDashboardSearchCriteria);
  }

  findEligibilityTrackDashboardList(eligibilityDashboardSearchCriteria: any){
    return this.http.post(this.url.getEligibilityTrackDashboardList, eligibilityDashboardSearchCriteria);
  }

  getEligibilityProcessHistory(eligibilityCertificateId: any, sort: any) {
    const obj = {
      eligibilityCertificateId : this.ced.encryptAesToString(eligibilityCertificateId, this.serverURL.secretKey).toString(),
      sort: sort
    }
    return this.http.post(this.url.getEligibilityProcessHistory, obj);
  }

  assignEligibilityCertificate(data: any) {
    return this.http.post(this.url.assignEligibilityCertificate, data);
  }

  getEligibilityNoteSheetPurpose() {
    return this.http.get(this.url.getEligibilityNoteSheetPurpose);
  }

  // Eligibility Workfloq Document  
  eligibilityWorkflowWithDocument(obj: any, filearray: any) {
    const formdata = new FormData();
    formdata.append('eligibilityEncryptDTOStr', JSON.stringify(obj));
    for (let i = 0; i < filearray.length; i++) {
      formdata.append('file', filearray[i]);
    }
    return this.http.post(this.url.eligibilityWorkflowWithDocument, formdata);
  }
    
  getEligibilityViewPdf(eligibilityCertificateId: any) {
    const obj = {
      eligibilityCertificateId : this.ced.encryptAesToString(eligibilityCertificateId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getEligibilityViewPdf, obj);
  }

  //getAllComplaintListCount
  getAllEligibilityListCount(){
    return this.http.get(this.url.getECListCount);
  }


}
